// As strings do voucher de pagamento no esqueleto novo (`buildPaymentVoucherView`, #5033), em
// arquivo próprio pelo mesmo motivo do `hotel_voucher_catalog.ts`: o catálogo principal tem
// teto de 500 linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.paymentVoucher.title': 'Pagamento',
  'trips.paymentVoucher.dates': 'Despesa · {{date}}',
  'trips.paymentVoucher.method.PIX': 'Transferência/Pix',
  'trips.paymentVoucher.method.CREDIT_CARD': 'Cartão corporativo',
  'trips.paymentVoucher.methodLabel': 'Meio de pagamento',
  'trips.paymentVoucher.balanceRequest': 'Solicitação de saldo',
  'trips.paymentVoucher.payee': 'Destino',
  'trips.paymentVoucher.document': 'Documento',
  'trips.paymentVoucher.bank': 'Banco',
  'trips.paymentVoucher.pixKey': 'Chave pix',
  'trips.paymentVoucher.pixKeyQrCode': 'Via QR Code',
  'trips.paymentVoucher.transaction': 'Transação',
  'trips.paymentVoucher.establishment': 'Estabelecimento',
  'trips.paymentVoucher.transactionId': 'ID da transação',
  'trips.paymentVoucher.category': 'Categoria',
  'trips.paymentVoucher.proof': 'Comprovante',
  'trips.paymentVoucher.invoice': 'Nota fiscal',
  'trips.paymentVoucher.nfce': 'NFC-e (QR Code)',
  'trips.paymentVoucher.addReceipt': 'Adicionar comprovante',
  'trips.paymentVoucher.status.approved': 'Aprovado',
  'trips.paymentVoucher.status.declined': 'Recusado',
  'trips.paymentVoucher.approvedOn': 'Aprovado em {{date}}',
  // O grupo dos campos extras da prestação de contas: serve também ao voucher de reembolso.
  'trips.voucher.additionalFields': 'Informações adicionais',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.paymentVoucher.title': 'Payment',
  'trips.paymentVoucher.dates': 'Expense · {{date}}',
  'trips.paymentVoucher.method.PIX': 'Transfer/Pix',
  'trips.paymentVoucher.method.CREDIT_CARD': 'Corporate card',
  'trips.paymentVoucher.methodLabel': 'Payment method',
  'trips.paymentVoucher.balanceRequest': 'Balance request',
  'trips.paymentVoucher.payee': 'Payee',
  'trips.paymentVoucher.document': 'Document',
  'trips.paymentVoucher.bank': 'Bank',
  'trips.paymentVoucher.pixKey': 'Pix key',
  'trips.paymentVoucher.pixKeyQrCode': 'By QR code',
  'trips.paymentVoucher.transaction': 'Transaction',
  'trips.paymentVoucher.establishment': 'Merchant',
  'trips.paymentVoucher.transactionId': 'Transaction ID',
  'trips.paymentVoucher.category': 'Category',
  'trips.paymentVoucher.proof': 'Receipt',
  'trips.paymentVoucher.invoice': 'Invoice',
  'trips.paymentVoucher.nfce': 'NFC-e (QR code)',
  'trips.paymentVoucher.addReceipt': 'Add receipt',
  'trips.paymentVoucher.status.approved': 'Approved',
  'trips.paymentVoucher.status.declined': 'Declined',
  'trips.paymentVoucher.approvedOn': 'Approved on {{date}}',
  'trips.voucher.additionalFields': 'Additional information',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.paymentVoucher.title': 'Pago',
  'trips.paymentVoucher.dates': 'Gasto · {{date}}',
  'trips.paymentVoucher.method.PIX': 'Transferencia/Pix',
  'trips.paymentVoucher.method.CREDIT_CARD': 'Tarjeta corporativa',
  'trips.paymentVoucher.methodLabel': 'Medio de pago',
  'trips.paymentVoucher.balanceRequest': 'Solicitud de saldo',
  'trips.paymentVoucher.payee': 'Destino',
  'trips.paymentVoucher.document': 'Documento',
  'trips.paymentVoucher.bank': 'Banco',
  'trips.paymentVoucher.pixKey': 'Clave pix',
  'trips.paymentVoucher.pixKeyQrCode': 'Por código QR',
  'trips.paymentVoucher.transaction': 'Transacción',
  'trips.paymentVoucher.establishment': 'Establecimiento',
  'trips.paymentVoucher.transactionId': 'ID de la transacción',
  'trips.paymentVoucher.category': 'Categoría',
  'trips.paymentVoucher.proof': 'Comprobante',
  'trips.paymentVoucher.invoice': 'Factura',
  'trips.paymentVoucher.nfce': 'NFC-e (código QR)',
  'trips.paymentVoucher.addReceipt': 'Agregar comprobante',
  'trips.paymentVoucher.status.approved': 'Aprobado',
  'trips.paymentVoucher.status.declined': 'Rechazado',
  'trips.paymentVoucher.approvedOn': 'Aprobado el {{date}}',
  'trips.voucher.additionalFields': 'Información adicional',
};

export const PAYMENT_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
